import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect } from "react";

import Logo from "@/components/icons/Logo";
import Loading from "@/components/Loading";
import useAuthUser from "@/hooks/useAuthUser";
import useI18n from "@/hooks/useI18n";
import { LS_LANGUAGE_KEY } from "@/lib/constants";

function Login() {
  const { t } = useI18n();
  const router = useRouter();
  const { isLoading, user } = useAuthUser();

  // If the user has a language preference saved in local storage, we use it, whatever the language in the URL is
  useEffect(() => {
    const languageLs = localStorage.getItem(LS_LANGUAGE_KEY);
    if (!user && languageLs && router.query.lang !== languageLs) {
      // Redirect to the language used by the user
      void router.replace(`/${languageLs}/login`);
    } else if (user && router.query.lang) {
      // Redirect to the correct lang page
      void router.replace(`/${router.query.lang as string}/`);
    }
  }, [user, router]);

  if (isLoading || user) {
    return <Loading big />;
  }
  return (
    <div className="flex min-h-screen flex-col justify-center bg-gray-50 px-8">
      <Head>
        <title>{t("login.htmlTitle")}</title>
      </Head>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-xl">
        <div className="flex flex-col items-center gap-6 bg-white px-4 py-8 shadow-xs sm:rounded-lg sm:px-10">
          <div className="text-blue text-4xl font-bold">
            <Logo className="-ml-3 h-3" />
            {t("login.title")}
          </div>
          <a
            className="flex w-full max-w-[50%] justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-sm font-medium text-white shadow-2xs hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 focus:outline-hidden"
            href="/backend/oidc/authenticate/"
          >
            {t("login.login")}
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;
